import { Helmet } from 'react-helmet-async';
import '../EventsPage.css';
import './HotelsPage.css';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TextField,
  Pagination,
  Box,
  Grid,
  CircularProgress,
  Divider,
  Modal,
  MenuItem,
  Select,
  InputLabel,
  FormControlLabel,
  Radio,
} from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';

import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { AiTwotoneEdit, AiFillEye } from 'react-icons/ai';
import { FaLock, FaStreetView, FaUnlock } from 'react-icons/fa';
// components
import { LoadingButton } from '@mui/lab';
import { AppWidget } from '../../sections/@dashboard/app';
import Iconify from '../../components/iconify';
// sections
import { CREATE_HOTEL_RESET } from '../../redux/constants/hotelsConstant';
import { clearError, createHotel, getHotels, updateHotels } from '../../redux/actions/hotelsAction';
import HotelDetail from './HotelDetail';
import PackagesInrCard from './PackagesInrCard';
// import { set } from 'lodash';
// import { max } from 'lodash';
// import { over } from 'lodash';

// ----------------------------------------------------------------------
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 550,
  borderRadius: '0.4rem',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const viewHotelStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  borderRadius: '0.4rem',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  maxHeight: '90vh',
  overflow: 'scroll',
  p: 2,
};
const stackStyle = {
  width: '48%',
};
const NewHotelStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  borderRadius: '0.4rem',
  bgcolor: 'background.paper',
  // border: '2px solid #000',
  boxShadow: 24,
  maxHeight: '90vh',
  overflow: 'scroll',
  p: 4,
};
const NewHotelInput = {
  width: '100%',
};
export default function UserPage() {
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getHotels(keyword, page));
  }, [dispatch, page]);

  const {
    loading: getLoading,
    hotels,
    totalBoardHotels,
    totalHotels,
    error: getErr,
  } = useSelector((state) => state.getHotels);

  useEffect(() => {
    if (getErr) {
      toast.error(getErr);
      dispatch(clearError());
    }
  }, [getErr, navigate, dispatch]);

  // searchHandler
  const searchHandler = (e) => {
    e.prhotelDefault();
    dispatch(getHotels(keyword, page));
  };
  const handlePage = (hotel, value) => {
    setPage(value);
  };

  // if((totalUsers / resultPerPage) ===  0){
  // const count = totalUsers / resultPerPage
  // }else{
  //   const count = Math.round(totalUsers / resultPerPage)  + 1
  // }

  // -----------------------------new Hotel Modal Code --------------------------------------

  const {
    loading: createHotelLoading,
    success: createHotelSuccess,
    error,
  } = useSelector((state) => state.actionHotels);

  useEffect(() => {
    if (createHotelSuccess) {
      toast.success('updated success');
      HotelModalHandleClose();
      updateHotelModalHandleClose();
      // deleteHotelModalHandleClose()
      // recoverHotelModalHandleClose()
      dispatch({ type: CREATE_HOTEL_RESET });
      dispatch(getHotels(keyword, page));
    }
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, createHotelSuccess, dispatch]);

  const [hotelName, setHotelName] = useState('');
  const [hotelDate, setHoteldate] = useState('');
  const [bookingEndDate, setBookingEndDate] = useState('');
  const [hotelRegistrationfee, setHotelRegistrationfee] = useState('');
  const [sponsers, setSponsers] = useState('');
  const [activeForMember, setActiveForMember] = useState('');
  const [activeForWebsite, setActiveForWebsite] = useState('');
  const [totalSeats, setTotalSeats] = useState('');
  const [MarketingStatus, setMarketingStatus] = useState('');
  const [gst, setGst] = useState();
  const [isGst, setIsGst] = useState('true');
  const [packagesInr, setPackagesInr] = useState([
    {
      packageName: '',
      packagePrice: 0,
      totalSeats: '',
      nights: 1,
    },
  ]);

  //   const [memberPrice, setmemberPrice] = useState('');
  //   const [nonMemberPrice, setnonMemberPrice] = useState('');
  //   const [spouse, setspouse] = useState('');
  //   const [child1Price, setchild1] = useState('');
  //   const [child2Price, setchild2] = useState('');
  //   const [memberScientist, setmemberScientist] = useState('');
  //   const [ForeignPrice, setForeignPrice] = useState('');

  const [banner, setBanner] = useState('');

  const [bannerPreview, setBannerPreview] = useState('');
  const [HotelModalOpen, setHotelModalOpen] = useState(false);

  const HotelModalHandleOpen = () => {
    setHotelModalOpen(true);
  };
  const HotelModalHandleClose = () => {
    setHotelModalOpen(false);
  };

  const newHotelSubmitHandler = (e) => {
    e.preventDefault();

    if (
      //   memberPrice < 1 ||
      //   nonMemberPrice < 1 ||
      //   child2Price < 1 ||
      //   child1Price < 1 ||
      //   spouse < 1 ||
      //   memberScientist < 1 ||
      //   ForeignPrice < 1
      packagesInr?.length === 0
    ) {
      toast.error('Package details are required');
    } else {
      dispatch(
        createHotel({
          hotel_name: hotelName,
          hotel_date: hotelDate,
          booking_end_date: bookingEndDate,
          //   hotel_registration_fee: hotelRegistrationfee,
          banner,
          //   sponsers,
          //   totalSeats,
          //   MarketingStatus,
          isGst,
          gst,
          packagesInr,
          //   memberPrice,
          //   nonMemberPrice,
          //   child2Price,
          //   child1Price,
          //   spouse,
          //   memberScientist,
          //   ForeignPrice,
        })
      );
    }
  };

  const handleFileChange = (hotel) => {
    const file = hotel.target.files[0];
    // setfileName(file?.name)

    if (file) {
      if (file.size <= 1 * 1024 * 1024) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          setBanner(e.target.result);
          setBannerPreview(e.target.result);

          // console.log(selectedFile)
        };
      } else {
        hotel.target.value = null;
        setBanner(null);
        setBannerPreview(null);
        alert('File size exceeds the limit of 1 MB.');
      }
    } else {
      hotel.target.value = null;
      setBanner(null);
      setBannerPreview(null);
      alert('Please select an profile picture.');
    }
  };

  //  -------------------  update modal code  -----------------------------------
  const [updateItem, setUpdateItem] = useState();

  const [hotelUpdateName, setUpdateHotelName] = useState('');
  const [hotelUpdateDate, setUpdateHoteldate] = useState('');
  const [updateBookingEndDate, setUpdateBookingEndDate] = useState('');

  const [UpdateHotelRegistrationfee, setUpdateHotelRegistrationfee] = useState('');
  const [UpdateSponsers, setUpdateSponsers] = useState('');
  const [UpdateActiveForMember, setUpdateActiveForMember] = useState('');
  const [UpdateActiveForWebsite, setUpdateActiveForWebsite] = useState('');
  const [UpdateTotalSeats, setUpdateTotalSeats] = useState('');
  const [UpdateMarketingStatus, setUpdateMarketingStatus] = useState('');

  //   const [UpdatememberPrice, setUpdatememberPrice] = useState('');
  //   const [UpdatenonMemberPrice, setUpdatenonMemberPrice] = useState('');
  //   const [Updatespouse, setUpdatespouse] = useState('');
  //   const [Updatechild1Price, setUpdatechild1] = useState('');
  //   const [Updatechild2Price, setUpdatechild2] = useState('');
  //   const [UpdatememberScientist, setUpdatememberScientist] = useState('');
  //   const [UpdateForeignPrice, setUpdateForeignPrice] = useState('');

  const [UpdateGst, setUpdateGst] = useState('');
  const [UpdateIsGst, setUpdateIsGst] = useState('true');
  const [UpdatePackageInr, setUpdatePackageInr] = useState([
    {
      packageName: '',
      packagePrice: 0,
      totalSeats: '',
      nights: 1,
    },
  ]);

  const [UpdateBannerPreview, setUpdateBannerPreview] = useState('');

  // modal
  const [updateHotelModalOpen, setUpdateHotelModalOpen] = useState(false);

  const updateHotelModalHandleOpen = () => {
    setUpdateHotelModalOpen(true);
  };
  const updateHotelModalHandleClose = () => {
    setUpdateHotelModalOpen(false);
  };

  // form submit
  const updateHotelSubmitHandler = (e) => {
    e.preventDefault();
    if (UpdatePackageInr?.length === 0) {
      toast.warn('Package details are required');
    } else {
      const HotelDetails = {
        hotel_name: hotelUpdateName,
        hotel_date: hotelUpdateDate,
        // hotel_registration_fee: UpdateHotelRegistrationfee,
        sponsers: UpdateSponsers,
        activeForMember: UpdateActiveForMember,
        activeForWebsite: UpdateActiveForWebsite,
        totalSeats: UpdateTotalSeats,
        MarketingStatus: UpdateMarketingStatus,
        banner: UpdateBannerPreview,
        // memberPrice: UpdatememberPrice,
        // nonMemberPrice: UpdatenonMemberPrice,
        // child2Price: Updatechild2Price,
        // child1Price: Updatechild1Price,
        // spouse: Updatespouse,
        // memberScientist: UpdatememberScientist,
        // ForeignPrice: UpdateForeignPrice,
        // booking_end_date: updateBookingEndDate,

        gst: UpdateGst,
        isGst: UpdateIsGst,
        packagesInr: UpdatePackageInr,
      };

      dispatch(updateHotels(HotelDetails, updateItem?._id));
    }
  };

  const updateHandleFileChange = (hotel) => {
    const file = hotel.target.files[0];

    if (file) {
      if (file.size <= 1 * 1024 * 1024) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          setUpdateBannerPreview(e.target.result);
          // setUpdateProfilePreview(e.target.result);
        };
      } else {
        hotel.target.value = null;
        setUpdateBannerPreview(null);
        // setUpdateProfilePreview(null);
        alert('File size exceeds the limit of 1 MB.');
      }
    } else {
      hotel.target.value = null;
      setUpdateBannerPreview(null);
      // setUpdateProfilePreview(null);
      alert('Please select an profile picture.');
    }
  };

  const editHandle = (item) => {
    console.log(item);
    setUpdateItem(item);

    setUpdateHotelName(item.hotel_name);
    setUpdateHoteldate(item.hotel_date);
    setUpdateBookingEndDate(item.booking_end_date);
    setUpdateActiveForMember(item.activeForMember);
    setUpdateActiveForWebsite(item.activeForWebsite);
    // setUpdateBannerPreview(item.eve)
    // setUpdateHotelRegistrationfee(item.hotel_registration_fee);
    // setUpdateMarketingStatus(item.MarketingStatus);
    // setUpdateTotalSeats(item.totalSeats);
    // setUpdateSponsers(item.sponsers);
    // setUpdatenonMemberPrice(item?.nonMemberPrice);
    // setUpdatememberPrice(item?.memberPrice);
    // setUpdatechild1(item?.child1Price);
    // setUpdatechild2(item?.child2Price);
    // setUpdatememberScientist(item?.memberScientist);
    // setUpdateForeignPrice(item?.ForeignPrice);
    // setUpdatespouse(item?.spouse);

    setUpdatePackageInr(item?.packagesInr);
    setUpdateGst(item?.gst);
    setUpdateIsGst(item?.isGst.toString());

    updateHotelModalHandleOpen();
  };

  // view Hotel Modal code -----------------------------------------

  const [viewHotelModalOpen, setviewHotelModalOpen] = useState(false);
  const [hotelDetails, setHotelDetails] = useState('');

  const viewHotelModalHandleOpen = (item) => {
    setHotelDetails(item);
    setviewHotelModalOpen(true);
  };
  const viewHotelModalHandleClose = () => {
    setviewHotelModalOpen(false);
  };

  // view Bookings Modal code -----------------------------------------

  const [viewBookingsModalOpen, setviewBookingsModalOpen] = useState(false);
  //   const [BookingsDetails, setBookingsDetails] = useState('');

  const viewBookingsModalHandleOpen = (item) => {
    //   setBookingsDetails(item)
    setviewBookingsModalOpen(true);
  };
  const viewBookingsModalHandleClose = () => {
    setviewBookingsModalOpen(false);
  };

  // ----------------- Admin Authentication -----------------------------------------
  const { user } = useSelector((state) => state.users);
  if (user) {
    if (user.role !== 'admin') {
      navigate('/dashboard/app');
    }
  } else {
    navigate('/');
  }

  // ----------------- Admin Authentication end -----------------------------------------
  return (
    <>
      <Helmet>
        <title> Hotels - eoai </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <div className="totalComponents">
            <Grid item xs={12} sm={6} md={6}>
              <AppWidget title="Total Hotels" total={hotels?.length} icon={'ph:users-fill'} />
            </Grid>
            {/* <Grid item xs={12} sm={6} md={6}>
                            <AppWidget title="coming soon " total={totalBoardHotels} icon={'ph:users-fill'} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <AppWidget title="Completed " total={totalBoardHotels} icon={'ph:users-fill'} />
                        </Grid> */}
          </div>

          {/* <Link to={'/user/new'}> */}
          <Button variant="contained" onClick={HotelModalHandleOpen} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Hotels
          </Button>
          {/* </Link> */}
        </Stack>

        <div>
          <div className="tableTop">
            <div hidden={!getLoading ? 'true' : ''}>
              <CircularProgress color="primary" />
            </div>
            <div>Hotels</div>

            {/* <form onSubmit={searchHandler}>
                            <TextField type='text' onChange={e => setKeyword(e.target.value)} value={keyword} placeholder='Search user' size="small" label="Search user" variant="outlined" />
                        </form> */}
          </div>
          {/* <Divider /> */}

          {/* <div className="hotelsContainers">
            {hotels &&
              hotels.map((item) => (
                <Card>
                  <div className="hotel-Box">
                    <div className="hotelImgBoxl">
                      <img
                        src={
                          item.banner
                            ? item.banner.url
                            : 'https://us.123rf.com/450wm/arypsto/arypsto2104/arypsto210400138/168148723-colorful-layout-design-for-hotels-festivals-and-art-performances.jpg?ver=6'
                        }
                        alt="Hotel"
                      />
                    </div>

                    <div className="namePositionBoxx">
                      <h5>{item?.hotel_name}</h5>
                    </div>

                    <div className="actionBox">
                      <div className="hotel-icon-Box">
                        <Stack direction={'row'} spacing={1}>
                          <button className="ei_btn" onClick={(e) => editHandle(item)}>
                            <AiTwotoneEdit />
                          </button>
                          <Link className="ei_btn" onClick={(e) => viewHotelModalHandleOpen(item)}>
                            <AiFillEye />
                          </Link>
                        </Stack>
                        <p>
                          Active for website : <div className={item?.activeForWebsite ? 'live' : 'unlive'}> </div>
                        </p>
                        <p>
                          Active for Portal : <div className={item?.activeForMember ? 'live' : 'unlive'}> </div>
                        </p>
                        <Link
                          className="book_btn"
                          to={`/dashboard/bookings/${item._id}`}
                          style={{ textDecoration: 'none' }}
                        >
                          Bookings
                        </Link>
                      </div>
                    </div>
                  </div>
                </Card>
              ))}
          </div> */}

          <div className="hotel-list">
            {hotels &&
              hotels.map((item) => (
                <Card key={item._id} className="hotel-card">
                  <div className="hotel-card-inner">
                    {/* Image */}
                    <div className="hotel-image-wrapper">
                      <img
                        src={
                          item.banner
                            ? item.banner.url
                            : 'https://us.123rf.com/450wm/arypsto/arypsto2104/arypsto210400138/168148723-colorful-layout-design-for-hotels-festivals-and-art-performances.jpg?ver=6'
                        }
                        alt="Hotel"
                        className="hotel-image"
                      />
                    </div>

                    {/* Name */}
                    <div className="hotel-info">
                      <h5 className="hotel-name">{item?.hotel_name}</h5>
                    </div>

                    {/* Actions */}
                    <div className="hotel-actions">
                      <div className="hotel-action-icons">
                        <button className="icon-btn edit-btn" onClick={() => editHandle(item)}>
                          <AiTwotoneEdit />
                        </button>

                        <button className="icon-btn view-btn" onClick={() => viewHotelModalHandleOpen(item)}>
                          <AiFillEye />
                        </button>
                      </div>

                      <div>
                        {item?.packagesInr.map((pkg) => (
                          <div
                            key={pkg._id}
                            className="package-info"
                            style={{
                              border: '1px solid gray',
                              borderRadius: '8px',
                              padding: '8px 16px',
                              marginBottom: '4px',
                            }}
                          >
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: '15px',
                                textAlign: 'left ',
                                // padding: '4px',
                                marginBottom: '4px',
                              }}
                            >
                              {pkg.packageName}
                            </span>
                            <br />
                            <span style={{ fontSize: '14px', textAlign: 'left ' }}>
                              Price: ₹{pkg.packagePrice * pkg.nights} + {item?.gst}% Gst - for {pkg.nights} nights
                            </span>
                            <br />
                            <span style={{ fontSize: '14px', textAlign: 'left ' }}>
                              Total Seats: {pkg.totalSeats ? pkg.totalSeats : 'N/A'}
                            </span>
                            <br />
                            <span style={{ fontSize: '14px', textAlign: 'left ' }}>
                              Booked Seats: {pkg.bookedSeats ? pkg.bookedSeats : '0'}
                            </span>
                          </div>
                        ))}
                        {/* Total seats : {item?.totalSeats ? item?.totalSeats : 'N/A'} <br />
                        Booked Seats : {item?.bookedSeats ? item?.bookedSeats : '0'} */}
                      </div>

                      <div className="hotel-status">
                        <p>
                          Website :
                          <span className={item?.activeForWebsite ? 'status-dot active' : 'status-dot inactive'} />
                        </p>

                        <p>
                          Portal :
                          <span className={item?.activeForMember ? 'status-dot active' : 'status-dot inactive'} />
                        </p>
                      </div>

                      <Link className="booking-btn" to={`/dashboard/hotels/bookings/${item._id}`}>
                        Bookings
                      </Link>
                    </div>
                  </div>
                </Card>
              ))}
          </div>

          {/* <div className='paginationBox' >
                        <Pagination count={count} page={page} onChange={handlePage} color="primary" />
                    </div> */}
        </div>
      </Container>

      {/* New Hotel  modal code  */}
      <div>
        <Modal
          open={HotelModalOpen}
          // onClose={HotelModalHandleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={NewHotelStyle} className="hotelCreateBox">
            <Stack spacing={3} direction="row" justifyContent={'space-between'} marginBottom="0.8vmax ">
              <Typography id="modal-modal-title" variant="h5" component="h2">
                Create New Hotel
              </Typography>
              <Button onClick={HotelModalHandleClose} style={{ color: 'gray' }} variant="text">
                close
              </Button>
            </Stack>

            <Divider />

            <form action="" onSubmit={newHotelSubmitHandler}>
              <Stack spacing={2} margin="0.6vmax 0" direction="row">
                <Stack spacing={0} sx={stackStyle}>
                  <Stack spacing={2} margin="0.4vmax 0" direction="row">
                    <TextField
                      name="name"
                      size="small"
                      value={hotelName}
                      onChange={(e) => setHotelName(e.target.value)}
                      required
                      label="Hotel Name"
                      sx={NewHotelInput}
                    />
                  </Stack>
                  <Stack spacing={0} margin="0.6vmax 0">
                    <Typography variant="p" color="initial">
                      Hotel Date
                    </Typography>
                    <TextField
                      name="name"
                      type="date"
                      size="small"
                      value={hotelDate}
                      onChange={(e) => setHoteldate(e.target.value)}
                      required
                      // label="Hotel Date"
                      sx={NewHotelInput}
                    />
                  </Stack>
                  <Stack spacing={0} margin="0.6vmax 0">
                    <Typography variant="p" color="initial">
                      Booking end date
                    </Typography>

                    <TextField
                      name="name"
                      type="date"
                      size="small"
                      value={bookingEndDate}
                      onChange={(e) => setBookingEndDate(e.target.value)}
                      required
                      // label="Hotel Date"
                      sx={NewHotelInput}
                    />
                  </Stack>
                  {/* <Stack spacing={3} margin='0.6vmax 0'>
                                        <TextField name="phone"
                                            size='small'
                                            value={hotelRegistrationfee}
                                            onChange={e => setHotelRegistrationfee(e.target.value)}
                                            required label="Hotel Registration fee" />
                                    </Stack> */}
                  {/* <Stack spacing={3} margin="0.6vmax 0">
                    <TextField
                      name="Sponsors"
                      size="small"
                      value={sponsers}
                      onChange={(e) => setSponsers(e.target.value)}
                      required
                      label="Sponsors"
                    />
                  </Stack> */}
                  {/* <Stack spacing={3} margin="0.6vmax 0">
                    <TextField
                      name="totalSeats"
                      type="number"
                      size="small"
                      value={totalSeats}
                      onChange={(e) => setTotalSeats(e.target.value)}
                      required
                      label="Total seats"
                    />
                  </Stack> */}
                  {/* <Stack spacing={3} margin="0.6vmax 0">
                    <TextField
                      name="MarketingStatus"
                      size="small"
                      value={MarketingStatus}
                      onChange={(e) => setMarketingStatus(e.target.value)}
                      required
                      label="Marketing Status"
                    />
                  </Stack> */}

                  <PackagesInrCard packagesInr={packagesInr} setPackagesInr={setPackagesInr} gst={gst} isGst={isGst} />
                </Stack>

                <Stack sx={stackStyle}>
                  {/* memberScientist Delegates */}

                  <InputLabel id="demo-controlled-open-select-label">Is GST ?</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={isGst}
                      // label="Age"
                      displayEmpty
                      onChange={(e) => {
                        setIsGst(e.target.value);
                        setGst(0);
                      }}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  {isGst === 'true' && (
                    <Stack spacing={3} margin="0.6vmax 0">
                      <TextField
                        name="gst"
                        size="small"
                        type="number"
                        value={gst}
                        onChange={(e) => setGst(e.target.value)}
                        required
                        label="GST %"
                      />
                    </Stack>
                  )}

                  <InputLabel id="demo-controlled-open-select-label">Active for website</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={activeForWebsite}
                      // label="Age"
                      displayEmpty
                      onChange={(e) => setActiveForWebsite(e.target.value)}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  <InputLabel id="demo-controlled-open-select-label">Active for Portal</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={activeForMember}
                      // label="Age"
                      displayEmpty
                      onChange={(e) => setActiveForMember(e.target.value)}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  <InputLabel id="demo-controlled-open-select-label">Select Hotel Poster</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <input
                      className="inpProfileBtn"
                      required
                      type="file"
                      // accept=""
                      onChange={handleFileChange}
                      name="profile"
                      placeholder="Profile"
                    />
                    <img
                      src={
                        bannerPreview !== ''
                          ? bannerPreview
                          : 'https://media.istockphoto.com/id/1427946294/vector/red-color-inserted-label-banner-with-word-preview-on-white-background.jpg?s=612x612&w=0&k=20&c=Xbp2hzB7quoG03KuJ2ZqOj5Yos7I3iuTFR9pY8--OeQ='
                      }
                      className="bannerPreview"
                      alt="preview"
                      height={120}
                      width={'auto'}
                    />
                  </Stack>
                </Stack>
              </Stack>

              {/* <Stack spacing={3} margin='0.6vmax 0' >
                                <InputLabel id="demo-controlled-open-select-label">Select Container</InputLabel>

                                <Select

                                    labelId="demo-simple-select-helper-label"
                                    id="demo-simple-select-helper"
                                    value={flag}
                                    // label="Age"
                                    displayEmpty
                                    onChange={e => setFlag(e.target.value)}
                                    required
                                    size='small'
                                >
                                    <MenuItem value="">
                                        <em>None</em>
                                    </MenuItem>
                                    <MenuItem value={'board-Hotel'}>Board Hotel</MenuItem>
                                    <MenuItem value={'Hotel'}>Hotel</MenuItem>
                                    <MenuItem value={'special-invitee'}>Special invitee</MenuItem>
                                    <MenuItem value={'zonal'}>Zonal</MenuItem>
                                </Select>
                            </Stack> */}

              {createHotelLoading ? (
                <LoadingButton fullWidth size="large" variant="text">
                  <CircularProgress color="success" />
                </LoadingButton>
              ) : (
                <LoadingButton fullWidth size="medium" type="submit" variant="contained">
                  create
                </LoadingButton>
              )}
            </form>
          </Box>
        </Modal>
      </div>

      {/* update Hotel  modal code  */}
      <div>
        <Modal
          open={updateHotelModalOpen}
          onClose={updateHotelModalHandleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={NewHotelStyle} className="hotelCreateBox">
            <Stack spacing={3} direction="row" justifyContent={'space-between'} marginBottom="0.8vmax ">
              <Typography id="modal-modal-title" variant="h5" component="h2">
                Hotel Update
              </Typography>
              <Button onClick={updateHotelModalHandleClose} style={{ color: 'gray' }} variant="text">
                close
              </Button>
            </Stack>

            <Divider />

            <form action="" onSubmit={updateHotelSubmitHandler}>
              <Stack spacing={2} margin="0.6vmax 0" direction="row">
                <Stack spacing={0} sx={stackStyle}>
                  <Stack spacing={2} margin="0.4vmax 0" direction="row">
                    <TextField
                      name="name"
                      size="small"
                      value={hotelUpdateName}
                      onChange={(e) => setUpdateHotelName(e.target.value)}
                      required
                      label="Hotel Name"
                      sx={NewHotelInput}
                    />
                  </Stack>
                  <Stack spacing={0} margin="0.6vmax 0">
                    <Typography variant="p" color="initial">
                      Hotel Date
                    </Typography>

                    <TextField
                      name="name"
                      size="small"
                      type="date"
                      value={hotelUpdateDate}
                      onChange={(e) => setUpdateHoteldate(e.target.value)}
                      required
                      label=""
                      sx={NewHotelInput}
                    />
                  </Stack>
                  <Stack spacing={0} margin="0.6vmax 0">
                    <Typography variant="p" color="initial">
                      Booking End date
                    </Typography>
                    <TextField
                      name="name"
                      size="small"
                      type="date"
                      value={updateBookingEndDate}
                      onChange={(e) => setUpdateBookingEndDate(e.target.value)}
                      required
                      label=""
                      sx={NewHotelInput}
                    />
                  </Stack>

                  <PackagesInrCard
                    packagesInr={UpdatePackageInr}
                    setPackagesInr={setUpdatePackageInr}
                    gst={UpdateGst}
                    isGst={UpdateIsGst}
                  />
                </Stack>

                <Stack sx={stackStyle}>
                  <InputLabel id="demo-controlled-open-select-label">Is Gst ?</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={UpdateIsGst}
                      // label="Age"
                      //   displayEmpty
                      onChange={(e) => {
                        setUpdateIsGst(e.target.value);
                        setUpdateGst(0);
                      }}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  {UpdateIsGst === 'true' && (
                    <Stack spacing={3} margin="0.6vmax 0">
                      <TextField
                        name="gst"
                        size="small"
                        type="number"
                        value={UpdateGst}
                        onChange={(e) => setUpdateGst(e.target.value)}
                        required
                        label="GST %"
                      />
                    </Stack>
                  )}

                  <InputLabel id="demo-controlled-open-select-label">Active for website</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={UpdateActiveForWebsite}
                      // label="Age"
                      displayEmpty
                      onChange={(e) => setUpdateActiveForWebsite(e.target.value)}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  <InputLabel id="demo-controlled-open-select-label">Active for Portal</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={UpdateActiveForMember}
                      // label="Age"
                      displayEmpty
                      onChange={(e) => setUpdateActiveForMember(e.target.value)}
                      required
                      size="small"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'true'}>Yes</MenuItem>
                      <MenuItem value={'false'}>No</MenuItem>
                    </Select>
                  </Stack>

                  <InputLabel id="demo-controlled-open-select-label">Select Hotel Poster</InputLabel>
                  <Stack spacing={3} margin="0.6vmax 0">
                    <input
                      className="inpProfileBtn"
                      type="file"
                      // accept=""
                      onChange={updateHandleFileChange}
                      name="profile"
                      placeholder="Profile"
                    />
                    <img
                      src={
                        UpdateBannerPreview !== ''
                          ? UpdateBannerPreview
                          : 'https://media.istockphoto.com/id/1427946294/vector/red-color-inserted-label-banner-with-word-preview-on-white-background.jpg?s=612x612&w=0&k=20&c=Xbp2hzB7quoG03KuJ2ZqOj5Yos7I3iuTFR9pY8--OeQ='
                      }
                      className="bannerPreview"
                      alt="preview"
                      height={120}
                      width={'auto'}
                    />
                  </Stack>
                </Stack>
              </Stack>

              {createHotelLoading ? (
                <LoadingButton fullWidth size="large" variant="text">
                  <CircularProgress color="success" />
                </LoadingButton>
              ) : (
                <LoadingButton fullWidth size="medium" type="submit" variant="contained">
                  UPDATE
                </LoadingButton>
              )}
            </form>
          </Box>
        </Modal>
      </div>

      {/* view Hotel details  modal code  */}
      <div>
        <Modal
          open={viewHotelModalOpen}
          // onClose={HotelModalHandleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={viewHotelStyle} className="hotelCreateBox">
            <Stack spacing={3} direction="row" justifyContent={'space-between'} marginBottom="0.8vmax ">
              <Typography id="modal-modal-title" variant="h5" component="h2">
                Hotels
              </Typography>
              <Button onClick={viewHotelModalHandleClose} style={{ color: 'gray' }} variant="text">
                close
              </Button>
            </Stack>

            <Divider />
            <HotelDetail hotel={hotelDetails} />
          </Box>
        </Modal>
      </div>

      {/* view Hotel details  modal code  */}
      <div>
        <Modal
          open={viewBookingsModalOpen}
          // onClose={HotelModalHandleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={viewHotelStyle} className="hotelCreateBox">
            <Stack spacing={3} direction="row" justifyContent={'space-between'} marginBottom="0.8vmax ">
              <Typography id="modal-modal-title" variant="h5" component="h2">
                Hotels Bookings
              </Typography>
              <Button onClick={viewBookingsModalHandleClose} style={{ color: 'gray' }} variant="text">
                close
              </Button>
            </Stack>

            <Divider />
            <div>
              <Stack
                direction={'row'}
                padding={'4vmax 6vmax'}
                spacing={4}
                alignItems={'top'}
                justifyContent={'center'}
                margin={'6vmax'}
                borderRadius={2}
                border={1}
              >
                <Typography variant="h3" color="initial">
                  Currently No Booking
                </Typography>
              </Stack>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}
